
import Vue from 'vue'
import peopleService from "@/services/admin/peopleService";
import { UserInfo } from "@/types/User";
import { PortalUserInfo } from '@/types/admin/User';

export default Vue.extend({
    name: "PortalUserDetails",
    props: {
        personId: { type: Number },
    },
    data: function () {
      return {
          portalUserInfo: {} as PortalUserInfo,
          processingRequest: false,
          showProvideRemoveUserAccountReason: false,
          explanation: '',
      }
    },
    created: function () {
        if (this.personId) {
        peopleService
            .getPortalUserById(this.personId)
            .then((res) => {
            this.portalUserInfo = res;
            })
            .catch((e) => console.log(e));
        }
    },
    computed: {
        userInfo(): UserInfo {
            return this.$store.state.userInfo;
        },
    },
    watch: {
        personId: function (newVal: String) {
            peopleService
                .getPortalUserById(this.personId)
                .then((res) => {
                    this.portalUserInfo = res;
                })
                .catch((e) => console.log(e));
            },        
    },
    methods: {
        reloadUserInfo: function(personId: number) {
            peopleService
                .getPortalUserById(personId)
                .then((res) => {
                    this.$data.portalUserInfo = res;
                    this.explanation = '';
                    this.showProvideRemoveUserAccountReason = false;
                    this.processingRequest = false;
                })
                .catch((e) => console.log(e));
        },
        changePortalUserRole: function () {
            peopleService
                .changePortalUserRole(this.personId)
                .then((res) => {
                    this.portalUserInfo = res;
                    window.location.reload();
                })
                .catch((e) => console.log(e));

        },   
        provideRemoveUserAccountReason: function () {
            this.$data.showProvideRemoveUserAccountReason = true;
        },     
        removeUserAccount: function () {
            this.showProvideRemoveUserAccountReason = false;
            this.processingRequest = true;
            peopleService
                .removeUserAccount(this.portalUserInfo.personId, this.portalUserInfo.username, this.explanation)
                .then((res) => {
                    this.reloadUserInfo(this.personId);
                    window.location.reload();
                })
                .catch((e) => console.log(e))
                .finally(() => this.processingRequest = false);
        }
    },
})
